import { ITab } from 'legacy/lut/classes/models/ITab'
import React, { ReactNode, useEffect, useRef, useState } from 'react'

import { ScrollButton } from './ScrollButton'

import styles from './ScrollWrapper.module.scss'

interface IScrollWrapper {
  children: ReactNode
  tabs?: ITab[]
}

type IButtonState = 'hidden' | 'inactive' | 'active'

interface IScrollButton {
  left: IButtonState
  right: IButtonState
}

export const ScrollWrapper = ({ children, tabs }: IScrollWrapper) => {
  const rootRef = useRef<HTMLDivElement>(null)
  const [buttonsVisible, setButtonsVisible] = useState<IScrollButton>({
    left: 'hidden',
    right: 'hidden',
  })

  const checkHorizontalScroll = () => {
    if (rootRef.current) {
      const { scrollWidth, clientWidth, scrollLeft } = rootRef.current
      if (scrollWidth > clientWidth) {
        setButtonsVisible({
          left: scrollLeft > 0 ? 'active' : 'inactive',
          right: Math.floor(clientWidth + scrollLeft) !== scrollWidth ? 'active' : 'inactive',
        })
      } else {
        setButtonsVisible({
          left: 'hidden',
          right: 'hidden',
        })
      }
    }
  }

  const checkHorizontalScrollDelayed = () => {
    setTimeout(checkHorizontalScroll, 10)
  }

  useEffect(() => {
    checkHorizontalScrollDelayed()
    window.addEventListener('resize', checkHorizontalScrollDelayed)
    return () => {
      window.removeEventListener('resize', checkHorizontalScrollDelayed)
    }
  }, [rootRef, tabs])

  return (
    <div className={styles.tabs}>
      <ScrollButton rootRef={rootRef} direction={'left'} type={buttonsVisible.left} />
      <div className={styles.tabs_container} ref={rootRef} onScroll={checkHorizontalScroll}>
        {children}
      </div>
      <ScrollButton rootRef={rootRef} direction={'right'} type={buttonsVisible.right} />
    </div>
  )
}
